import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/home/index.vue"
import store from "../store/index.js"
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
    // meta: {
    //   keepAlive: true // 需要缓存
    // }
  },
  {
    path: "/product/",
    name: "Product",
    component: () => import("@/views/product/index.vue"),
    beforeEnter: (to, from, next) => {
      if (from.name === "flightDetail") {
        next({ name: from.name, query: { ...to.query }, replace: true })
      } else next()
    },
  },
  {
    path: "/product/detail/:id",
    name: "ProductDetail",
    component: () => import("@/views/product/Detail.vue"),
  },
  {
    path: "/product/submitOrder/:pid",
    name: "ProductSubmitOrder",
    component: () => import("@/views/product/submitOrder.vue"),
  },
  {
    path: "/product/dealOrder",
    name: "ProductDealOrder",
    component: () => import("@/views/product/dealOrder.vue"),
  },
  {
    path: "/flight/",
    name: "flightList",
    component: () => import("@/views/flight/index.vue"),
    props: (route) => ({ q: route.query }),
  },
  {
    path: "/flight/detail/:id",
    name: "flightDetail",
    component: () => import("@/views/flight/Detail.vue"),
  },
  {
    path: "/test/",
    component: () => import("@/views/Test.vue"),
    props: (route) => ({ q: route.query }),
  },

  {
    path: '/help',
    name: "help",
    component: () => import("@/views/help/index.vue"),
    redirect: { name: "helpCenter" },
    children: [
      {
        path: "helpCenter",
        name: "helpCenter",
        component: () => import("@/views/help/helpCenter")
      },
      {
        path: "serveState",
        name: "serveState",
        component: () => import("@/views/help/serveState")
      },
      {
        path: "callus",
        name: "callus",
        component: () => import("@/views/help/aboutUs/callus.vue")
      },
      {
        path: "feedback",
        name: "feedback",
        component: () => import("@/views/help/aboutUs/feedback.vue")
      },
      {
        path: "huayibao",
        name: "huayibao",
        component: () => import("@/views/help/aboutUs/huayibao.vue")
      },

      {
        path: "news",
        name: "news",
        component: () => import("@/views/help/aboutUs/news.vue")
      }

    ]
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("@/views/help/aboutUs/newsDetail"),

  },
  {
    path: "/cusprocess",
    name: "cusprocess",
    component: () => import("@/views/help/cusprocess"),

  },
  {
    path: "/store/index",
    name: "store",
    component: () => import("@/views/store/index.vue"),
  },
  {
    path: "/mine",
    component: () => import("@/views/mine/index.vue"),
    beforeEnter: (to, from, next) => {
      if (store.state.user.user.id) {
        next()
      } else {
        next({ name: from.name, query: { isLogin: false } })
      }
    },
    children: [
      {
        path: "center",
        name: "Center",
        component: () => import(/* webpackChunkName: "Center" */ "@/views/mine/Center.vue"),
      },
      {
        path: "wallet",
        name: "Wallet",
        component: () => import(/* webpackChunkName: "Wallet" */ "@/views/mine/wallet/Wallet.vue"),
      },
      {
        path: "cart/",
        name: "Cart",
        component: () => import(/* webpackChunkName: "Cart" */ "@/views/mine/Cart.vue"),
      },
      {
        path: "message",
        name: "Message",
        component: () => import(/* webpackChunkName: "Message" */ "@/views/mine/Message.vue"),
      },
      {
        path: "favorite",
        name: "Favorite",
        component: () => import(/* webpackChunkName: "Favorite" */ "@/views/mine/Favorite.vue"),
      },
      {
        path: "address",
        name: "Address",
        component: () => import(/* webpackChunkName: "Address" */ "@/views/mine/Address.vue"),
      },
      {
        path: "order/:wh?",
        name: "OrderList",
        component: () => import(/* webpackChunkName: "List" */ "@/views/mine/order/List.vue"),
      },
      {
        path: "order/detail/:id",
        name: "OrderDetail",
        component: () => import(/* webpackChunkName: "OrderDetail" */ "@/views/mine/order/Detail.vue"),
      },
      {
        path: "supplierproducts",
        name: "SupplierProducts",
        component: () => import(/* webpackChunkName: "SupplierProduct" */ "@/views/mine/SupplierProducts.vue"),
      },
      {
        path: "supplierpresell",
        name: "SupplierPresell",
        component: () => import(/* webpackChunkName: "SupplierProduct" */ "@/views/mine/SupplierPresell.vue"),
      },
      {
        path: "supplierorder",
        name: "SupplierOrder",
        component: () => import(/* webpackChunkName: "SupplierOrder" */ "@/views/mine/SupplierOrder.vue"),
      },
      {
        // path: "sup/detail/:id",
        path: "supplierorder/detail:id",
        name: "SupOrderDetail",
        component: () => import(/* webpackChunkName: "SupplierOrder" */ "@/views/sup/orderDetail.vue"),
      },
      {
        path: "/mine/payinfo",
        name: "evaluation",
        component: () => import("@/views/mine/payinfo.vue"),
      },
      {
        path: "supplierorder",
        name: "SupplierOrder",
        component: () => import(/* webpackChunkName: "SupplierOrder" */ "@/views/mine/SupplierOrder.vue"),
      },
      {
        path: "addprice",
        name: "Addprice",
        component: () => import(/* webpackChunkName: "Addprice" */ "@/views/mine/Addprice.vue"),
      },
      {
        path:'scanPurchase',
        name:'ScanPurchase',
        component: () => import(/* webpackChunkName: "Addprice" */ "@/views/mine/ScanPurchase.vue")
      }
    ],
  },
  {
    path: "/mine/wallet/topUp",
    name: "topUp",
    component: () => import("@/views/mine/wallet/topUp.vue"),
  },
  {
    path: "/mine/wallet/addCard",
    name: "addCard",
    component: () => import("@/views/mine/wallet/addCard.vue"),
  },
  {
    path: "/mine/wallet/withdrawal",
    name: "withdrawal",
    component: () => import("@/views/mine/wallet/withdrawal.vue"),
  },
  {
    path: "/mine/wallet/confirmWithdrawal",
    name: "confirmWithdrawal",
    component: () => import("@/views/mine/wallet/confirmWithdrawal"),
  },
  {
    path: "/mine/wallet/manageCard",
    name: "manageCard",
    component: () => import("@/views/mine/wallet/manageCard.vue"),
  },
  {
    path: "/mine/order/evaluation/:id",
    name: "evaluation",
    component: () => import("@/views/order/evaluation.vue"),
  }
]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0
  next()
})

export default router
